import { InjectionToken } from '@angular/core';

export interface BasicAuthInterceptorConfigInterface {
  basic_auth: string;
  urlPattern: string;
}

export const BASIC_AUTH_INTERCEPTOR_CONFIG = new InjectionToken<BasicAuthInterceptorConfigInterface>(
  'BASIC_AUTH_INTERCEPTOR_CONFIG'
);
